export default [
  [`Размер`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `44-46`, `48-50`, `50-52`, `52-54`, `54-56`],
  [`Обхват бёдер, см`, `96`, `100`, `104`, `108`, `112`],
  [`Рост, см`, `176-182`, `176-182`, `176-182`, `176-182`, `176-182`]
];
